// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Input from "react-toolbox/lib/input"
import * as paymentCalculation from "../../../paymentAgreementCalculation"
import * as strings from "../../../strings"
import _ from "lodash"
import Division from "../../../components/Division"
import { formatDate } from "../../../utils"
import DatePicker from "../../../components/DatePicker"

const MAX_NUMBER_OF_PAYMENTS = 720
const STEP_VALUE = "0.01"
const NUMBER_OF_DECIMAL_PLACES = 2

export default class Payments extends Component {
  props: {
    paymentAgreementState: any,
    onChange: any,
    interestTypes: any,
    isPreLitigation: any,
  }

  handleCapitalValue = () => {
    const { paymentAgreementState } = this.props
    let capitalValue = paymentAgreementState.capitalValue
    if ( !capitalValue ) {
      capitalValue = _.round( _.sum( paymentAgreementState.pickedInvoices.map( invoice =>
        parseFloat( invoice.value ) ) ) + _.sum( paymentAgreementState.addedInvoices.map( invoice =>
        parseFloat( invoice.value ) ) ), 2 )
    }
    this.props.onChange( {
      capitalValue,
      ...paymentCalculation.handleChangedCapitalValue( paymentAgreementState.debtValue,
        paymentAgreementState.justiceTax, paymentAgreementState.interestValue,
        paymentAgreementState.numberOfPayments, capitalValue,
        paymentAgreementState.valuePerPayment, paymentAgreementState.firstPaymentDate,
        paymentAgreementState.isByPayments ),
    } )
  }

    renderInputs = () => {

      const { generalStrings } = strings
      const { paymentAgreementState } = this.props

      return (
        <div className={style.bottomContent}>
          <div className={style.firstBottom}>
            <div className={style.bottomColumn}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.handleCapitalValue() } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  label={strings.paymentAgreements.capitalValue}
                  value={paymentAgreementState.capitalValue ? paymentAgreementState.capitalValue : generalStrings.emptyString}
                  onChange={value => this.props.onChange( {
                    capitalValue: value !== "" ? _.round( parseFloat( value ), NUMBER_OF_DECIMAL_PLACES ) : undefined,
                  } )}
                  onBlur={ () => this.handleCapitalValue() }
                  type="number" min="0" name="bills" step={STEP_VALUE}/>
              </form>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.props.onChange( {
                  ...paymentCalculation.handleChangedDebt( paymentAgreementState.debtValue,
                    paymentAgreementState.justiceTax, paymentAgreementState.interestValue,
                    paymentAgreementState.numberOfPayments, paymentAgreementState.capitalValue,
                    paymentAgreementState.valuePerPayment, paymentAgreementState.firstPaymentDate,
                    paymentAgreementState.isByPayments ),
                } ) } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  label={strings.paymentAgreements.debtValue}
                  value={paymentAgreementState.debtValue ? paymentAgreementState.debtValue : generalStrings.emptyString}
                  onChange={value => this.props.onChange( {
                    debtValue: value !== "" ? _.round( parseFloat( value ), NUMBER_OF_DECIMAL_PLACES ) : undefined,
                  } )}
                  onBlur={ () => {
                    return this.props.onChange( {
                      ...paymentCalculation.handleChangedDebt( paymentAgreementState.debtValue,
                        paymentAgreementState.justiceTax, paymentAgreementState.interestValue,
                        paymentAgreementState.numberOfPayments, paymentAgreementState.capitalValue,
                        paymentAgreementState.valuePerPayment, paymentAgreementState.firstPaymentDate,
                        paymentAgreementState.isByPayments ),
                    } ) } }
                  type="number" min="0" name="bills" step={STEP_VALUE}/>
              </form>
            </div>
            <div className={style.bottomColumn}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                this.props.onChange( {
                  ...this.justiceOrInterestValueOnBlur( paymentAgreementState.interestValue, false ),
                } )
              } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  label={strings.paymentAgreements.interestValue}
                  value={paymentAgreementState.interestValue ? paymentAgreementState.interestValue : generalStrings.emptyString}
                  onChange={value => this.props.onChange( {
                    interestValue: value !== "" ? parseFloat( value ) : undefined,
                  } )}
                  onBlur={ () => {
                    this.props.onChange( {
                      ...this.justiceOrInterestValueOnBlur( paymentAgreementState.interestValue, false ),
                    } )
                  } }
                  type="number" min="0" step={STEP_VALUE} name="bills" />
              </form>
            </div>
            <div className={style.bottomColumnErrorFix}>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                if ( paymentAgreementState.numberOfPayments <= MAX_NUMBER_OF_PAYMENTS ) {
                  return this.props.onChange( {
                    ...paymentCalculation.handlePayments( paymentAgreementState.numberOfPayments,
                      paymentAgreementState.debtValue, paymentAgreementState.firstPaymentDate ),
                  } )
                } else {
                  return undefined
                }
              } }>
                <Input
                  label={strings.paymentAgreements.numberOfPayments}
                  error={( paymentAgreementState.numberOfPayments || 0 ) > MAX_NUMBER_OF_PAYMENTS ? "Número máximo de prestações: " + MAX_NUMBER_OF_PAYMENTS : paymentAgreementState.arePaymentInputsValid[ 0 ]}
                  value={paymentAgreementState.numberOfPayments ? paymentAgreementState.numberOfPayments : generalStrings.emptyString}
                  onChange={value => value !== generalStrings.emptyString ? this.props.onChange( {
                    numberOfPayments: parseFloat( value ),
                  } ) : this.props.onChange( {
                    numberOfPayments: undefined,
                  } ) }
                  onBlur={() => {
                    if ( paymentAgreementState.numberOfPayments <= MAX_NUMBER_OF_PAYMENTS ) {
                      return this.props.onChange( {
                        ...paymentCalculation.handlePayments( paymentAgreementState.numberOfPayments,
                          paymentAgreementState.debtValue, paymentAgreementState.firstPaymentDate ),
                      } )
                    } else {
                      return undefined
                    }
                  }}
                  type="number" min="1" name="bills" />
              </form>
              <form onSubmit={ ( e ) => {
                e.preventDefault()
                return this.props.onChange( {
                  ...paymentCalculation.handlePaymentByValue( paymentAgreementState.valuePerPayment,
                    paymentAgreementState.debtValue, paymentAgreementState.firstPaymentDate ),
                } ) } }>
                <Input
                  className={style.inputFieldsPrefix}
                  icon={"euro_symbol"}
                  label={strings.paymentAgreements.valuePerPayment}
                  error={paymentAgreementState.arePaymentInputsValid[ 1 ]}
                  value={paymentAgreementState.valuePerPayment ? paymentAgreementState.valuePerPayment : generalStrings.emptyString}
                  onChange={value => value !== generalStrings.emptyString ?
                    this.props.onChange( {
                      valuePerPayment: _.round( parseFloat( value ), 2 ),
                    } ) :
                    this.props.onChange( {
                      valuePerPayment: undefined,
                    } )
                  }
                  onBlur={() => this.props.onChange( {
                    ...paymentCalculation.handlePaymentByValue( paymentAgreementState.valuePerPayment,
                      paymentAgreementState.debtValue, paymentAgreementState.firstPaymentDate ),
                  } )
                  }
                  type="number" min="0" step={STEP_VALUE} name="bills" />
              </form>
            </div>
            <div className={style.bottomColumn}>
              <div className={style.datePickerFieldsPrefix}>
                <DatePicker
                  icon="event"
                  label={strings.paymentAgreements.firstPaymentDate}
                  onChange={ event => {
                    return this.props.onChange( {
                      firstPaymentDate: event,
                      paymentDates: paymentCalculation.updateDates( paymentAgreementState.numberOfPayments,
                        event ),
                    } ) }}
                  value={ paymentAgreementState.firstPaymentDate }
                />
              </div>
              {!this.props.isPreLitigation && 
                <form onSubmit={ ( e ) => {
                  e.preventDefault()
                  return this.props.onChange( {
                    ...this.justiceOrInterestValueOnBlur( paymentAgreementState.justiceTax, true ),
                  } )
                } }>
                  <Input
                    className={style.inputFieldsPrefix}
                    icon={"euro_symbol"}
                    label={strings.paymentAgreements.justiceTax}
                    type="number" min="0" step={STEP_VALUE}
                    error={paymentAgreementState.arePaymentInputsValid[ 2 ]}
                    value={paymentAgreementState.justiceTax !== undefined ? paymentAgreementState.justiceTax : generalStrings.emptyString}
                    onChange={value => this.props.onChange( {
                      justiceTax:  value !== generalStrings.emptyString ? _.round( parseFloat( value ), 2 ) : undefined,
                    } )}
                    onBlur={() => {
                      this.props.onChange( {
                        ...this.justiceOrInterestValueOnBlur( paymentAgreementState.justiceTax, true ),
                      } )
                    }}/>
                </form>
              }
            </div>
          </div>
        </div>
      )
    }


    justiceOrInterestValueOnBlur = ( valueToAdd, isJusticeTax ) => {
      const { paymentAgreementState } = this.props
      let newDebtValue

      if ( isJusticeTax ) {
        let justiceTax = valueToAdd || 0
        newDebtValue = _.round( ( paymentAgreementState.capitalValue + ( paymentAgreementState.
          interestValue ? paymentAgreementState.interestValue : 0 ) + justiceTax ), 2 )
      } else {
        let interestValue = valueToAdd || 0
        newDebtValue = _.round( ( paymentAgreementState.capitalValue + ( paymentAgreementState.
          justiceTax ? paymentAgreementState.justiceTax : 0 ) + interestValue ), 2 )
      }

      return {
        ...paymentCalculation.handleChangedDebt( newDebtValue,
          paymentAgreementState.justiceTax, paymentAgreementState.interestValue,
          paymentAgreementState.numberOfPayments, paymentAgreementState.capitalValue,
          paymentAgreementState.valuePerPayment, paymentAgreementState.firstPaymentDate,
          paymentAgreementState.isByPayments ),
      }
    }

    renderPaymentsInformation = () => {

      const { generalStrings } = strings
      const { paymentAgreementState } = this.props

      return (
        <div className={style.contentContainer}>
          <table className={style.tableCss}>
            <thead>
              <tr className={style.border}>
                <td className={style.tableTitle}><b>{strings.paymentAgreements.numberOfPayments}</b></td>
                <td className={style.tableTitle}><b>{strings.paymentAgreements.limitDate}</b></td>
                <td className={style.tableTitle}><b>{strings.paymentAgreements.paymentValue}</b></td>
              </tr>
            </thead>
            <tbody>
              {_.times( paymentAgreementState.payments.length, i => {
                return (
                  <tr className={style.noPadding}>
                    <td className={style.tableTitle}>{i + 1}</td>
                    <td className={style.tableTitle}>{formatDate( paymentAgreementState.paymentDates[ i ] )}</td>
                    <td className={style.tableTitle}>
                      <form onSubmit={ ( e ) => {
                        e.preventDefault()
                        return this.props.onChange( {
                          ...paymentCalculation.handleChangedPayments(
                            parseFloat( paymentAgreementState.payments[ i ] ), paymentAgreementState.isChangedPayment,
                            paymentAgreementState.payments, paymentAgreementState.debtValue ),
                        } )
                      } }>
                        <Input type="number"
                          step={STEP_VALUE}
                          value={paymentAgreementState.payments[ i ]}
                          onChange={event => {
                            let newPayments = [ ...paymentAgreementState.payments ]
                            newPayments[ i ] = event !== generalStrings.emptyString ? parseFloat( event ) : undefined

                            let newIsChangedPayment = [ ...paymentAgreementState.isChangedPayment ]
                            newIsChangedPayment[ i ] = event !== generalStrings.emptyString ? true : false,

                            this.props.onChange( {
                              payments: newPayments,
                              isChangedPayment: newIsChangedPayment,
                            } )
                          }} onBlur={( event ) => {
                            let newEvent = event.target.value === generalStrings.emptyString ? undefined : event.target.value
                            return this.props.onChange( {
                              ...paymentCalculation.handleChangedPayments(
                                newEvent, paymentAgreementState.isChangedPayment,
                                paymentAgreementState.payments, paymentAgreementState.debtValue ),
                            } ) }
                          }
                        />
                      </form>
                    </td>
                  </tr>
                ) } ) }
            </tbody>
          </table>

        </div>
      )
    }

    render () {
      const { paymentAgreements } = strings
      const { paymentAgreementState } = this.props

      let showStyle = paymentAgreementState.payments.length !== 0
      && Object.values( paymentAgreementState.paymentDates ).length !== 0 ?
        style.showContent : style.hiddenContent

      return (
        <div className={style.mainContainer}>
          <div className={style.infoPayments}>

            <Division title={paymentAgreements.agreedPaymentAgreementTitle}/>

            {this.renderInputs()}

            { paymentAgreementState.numberOfPayments <= MAX_NUMBER_OF_PAYMENTS ?
              <div className={showStyle}>

                <Division title={paymentAgreements.payments}/>

                {this.renderPaymentsInformation()}

              </div> : <div/> }
          </div>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/views/CreatePaymentAgreementPage/Payments/index.js